<template>
  <div class="profile-page">
    <!-- Header -->
    <header class="header">
      <div class="back-button">
        <el-icon><ArrowLeft /></el-icon>
      </div>
      <div class="title">个人中心</div>
      <div class="more-button">
        <el-icon><MoreFilled /></el-icon>
      </div>
    </header>
    <div class="website">www.deepark.com.cn</div>

    <!-- User Info -->
    <div v-if="loading" class="loading-indicator">Loading...</div>
    <div v-else class="user-profile-header">
      <div class="avatar-container" @click="navigateTo('/user/profile/details')">
          <el-avatar :size="60" :src="userInfo.avatar">
            <el-icon><UserFilled /></el-icon>
          </el-avatar>
      </div>
      <div class="user-info" @click="navigateTo('/user/profile/details')">
        <div class="user-phone">{{userInfo.nickName}}</div>
          <div class="user-phone">{{ formatPhone(userInfo.phone) }}</div>
        <div class="tagline">{{ userInfo.tagline }}</div>
      </div>
      <div class="service-button">
        <el-icon><Service /></el-icon>
        <span>客服</span>
      </div>
    </div>

    <!-- User Stats -->
    <div class="user-stats">
      <div class="stat-item" @click="toMonthCard">
        <!-- <div class="stat-value">{{myMonthlyCar.length}}</div> -->
        <div class="stat-value">{{ monthlyCardStatCount }}</div>
        <div class="stat-label">月卡</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">0</div>
        <div class="stat-label">共享收入</div>
        <div class="stat-badge">新</div>
      </div>
      <div class="stat-item" @click="goToCoupons">
        <div class="stat-value">{{ userInfo.couponCount || 0 }}</div>
        <div class="stat-label">优惠券</div>
      </div>
    </div>

    <!-- Membership Banner -->
    <div class="membership-banner">
      <div class="membership-info">
        <div class="membership-icon">
          <el-icon><Medal /></el-icon>
        </div>
        <div class="membership-text">
          <div class="membership-title">深度会员</div>
          <div class="membership-savings">累计已省 ¥8.88</div>
        </div>
      </div>
      <div class="subscribe-button">立即续费</div>
    </div>

    <!-- Recommended Services -->
    <div class="section-title">推荐服务</div>
    <div class="service-grid">
      <div class="service-item">
        <div class="service-icon fuel-icon"></div>
        <div class="service-name">优惠充电</div>
      </div>

      <div class="service-item">
        <div class="service-icon fee-icon"></div>
        <div class="service-name">跳费提醒</div>
      </div>
      <div class="service-item" @click="goToParkingSharing">
        <div class="service-icon release-icon"></div>
        <div class="service-name">发布共享</div>
      </div>
      <div class="service-item" @click="goToParking">
        <div class="service-icon parking-icon"></div>
        <div class="service-name">车位优选</div>
        <div class="badge">月卡</div>
      </div>
      <div class="service-item" @click="goToPostPaid">
        <div class="service-icon payment-icon"></div>
        <div class="service-name">先出后付</div>
      </div>
    </div>

    <!-- My Services -->
    <div class="section-title">我的服务</div>
    <div class="my-services-grid">
      <div class="my-service-item" @click="goToVehicles">
        <div class="my-service-icon car-icon"></div>
        <div class="my-service-name">我的车辆</div>
      </div>
      <div class="my-service-item" @click="goToOrders">
        <div class="my-service-icon order-icon"></div>
        <div class="my-service-name">我的订单</div>
      </div>
      <div class="my-service-item" @click="goToInvoice">
        <div class="my-service-icon invoice-icon"></div>
        <div class="my-service-name">电子发票</div>
      </div>
      <div class="my-service-item" @click="goToRefund">
        <div class="my-service-icon refund-icon"></div>
        <div class="my-service-name">补缴费用</div>
      </div>
      <div class="my-service-item" @click="goToPrivacy">
        <div class="my-service-icon privacy-icon"></div>
        <div class="my-service-name">隐私政策</div>
      </div>
      <div class="my-service-item" @click="goToLocation">
        <div class="my-service-icon location-icon"></div>
        <div class="my-service-name">位置授权</div>
      </div>
      <div class="my-service-item" @click="goToSettings">
        <div class="my-service-icon settings-icon"></div>
        <div class="my-service-name">设置</div>
      </div>
      <div class="my-service-item" @click="goToFeedback">
        <div class="my-service-icon feedback-icon"></div>
        <div class="my-service-name">意见反馈</div>
      </div>
      <div class="my-service-item" @click="goToBusiness">
        <div class="my-service-icon business-icon"></div>
        <div class="my-service-name">商务合作</div>
      </div>
      <div class="my-service-item" @click="goToParkingSpots">
        <div class="my-service-icon spot-icon"></div>
        <div class="my-service-name">我的车位</div>
      </div>
      <div class="my-service-item" @click="goToRsparkingMonthly">
        <div class="my-service-icon flag-icon">
          <el-icon :size="22"><Flag /></el-icon>
        </div>
        <div class="my-service-name">路侧包月</div>
      </div>
    </div>
  </div>

  <!-- Use the AppFooter component -->
  <AppFooter />
</template>

<script>
import { ref, onMounted } from 'vue'
import { ArrowLeft, MoreFilled, Service, Medal, UserFilled, Flag } from '@element-plus/icons-vue'
import AppFooter from '@/components/AppFooter.vue'
import { useRouter } from 'vue-router'
import { getUserProfile } from '@/api/user/profile'
import { selectMyMonthlyCard } from '@/api/parking/monthlyCardApply'
import { getUserCoupons } from '@/api/coupon/coupon'
import { getMyActiveMonthlyCardOrders } from '@/api/parking/monthlycardorder'
import { resolveOssImageUrlForDisplay } from '@/utils/ossImageUrl'
// import ProfileDetails from '@/views/user/profile/ProfileDetails.vue'
export default {
  name: 'UserProfile',
  components: {
    ArrowLeft,
    MoreFilled,
    Service,
    Medal,
    AppFooter,
    UserFilled,
    Flag,

    // ProfileDetails
  },
  setup() {
    const router = useRouter()

    // Define userInfo
    const userInfo = ref({
      avatar: '',
      phone: '',
      tagline: '深度停车，让停车更智慧',
      nickname: '',
      email: '',
      monthlyCards: 0,
      parkingCoins: 0,
      hasNewCoins: false,
      couponCount: 0
    })
    const loading = ref(true)

    // 格式化手机号
    const formatPhone = (phone) => {
      if (!phone) return ''
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    }

    const navigateTo = (path) => {
      router.push(path)
    }


    const fetchUserData = async () => {
      loading.value = true
      try {
        const response = await getUserProfile()
        console.log('API Response:', response)

        if (response.code === 200 && response.data) {
          console.log('User data:', response.data)

          // Log all properties to see what's available
          console.log('Available properties:', Object.keys(response.data))

          // Update userInfo with data from API
          userInfo.value = {
            ...userInfo.value,
            ...response.data,
            // The phone field might have a different name in your API
            phone: response.data.phone || response.data.phonenumber || response.data.mobile || '',
            avatar: response.data.avatar
              ? await resolveOssImageUrlForDisplay(response.data.avatar)
              : '',
            // Ensure couponCount is assigned correctly, checking multiple possible property names
            couponCount: response.data.couponCount || response.data.coupons || 0,
          }

          console.log('Updated userInfo:', userInfo.value)

          // Fetch coupon count separately
          fetchCouponCount()
        } else {
          console.error('Failed to get user profile:', response.msg)
        }
      } catch (error) {
        console.error('Error fetching user profile:', error)
      } finally {
        loading.value = false
      }
    }
    const goToParkingSharing = () => {
      router.push({ name: 'ParkingSharing' })
    }

    // Add a separate function to fetch coupon count
    const fetchCouponCount = async () => {
      try {
        const response = await getUserCoupons()
        console.log('Coupon response:', response)

        if (response.code === 200) {
          // Update the coupon count based on the rows array length
          const couponCount = response.data ? response.data.length : 0
          console.log('Found coupons:', couponCount)
          userInfo.value.couponCount = couponCount
        }
      } catch (error) {
        console.error('Error fetching coupon count:', error)
      }
    }

    // Call the function when component is mounted
    onMounted(() => {
      fetchUserData()
    })

    return {
      userInfo,  // Make sure userInfo is returned
      navigateTo,
      fetchUserData,
      formatPhone,
      loading,
      goToParkingSharing
    }
  },
  data() {
    return {
      myMonthlyCar: [],
      /** 直连购买的已支付月卡订单（与「我的月卡」页 cardListPay 同源） */
      myActiveMonthlyOrders: []
    }
  },
  computed: {
    monthlyCardStatCount() {
      const applies = Array.isArray(this.myMonthlyCar) ? this.myMonthlyCar.length : 0
      const orders = Array.isArray(this.myActiveMonthlyOrders) ? this.myActiveMonthlyOrders.length : 0
      return applies + orders
    }
  },
  mounted() {
    this.getMyCard()
  },
  methods: {
    getMyCard(){
      // selectMyMonthlyCard({}).then(response => {
      //   if ( response.data) {
      //         this.myMonthlyCar=response.data;
      //   }
      Promise.all([
        selectMyMonthlyCard({}),
        getMyActiveMonthlyCardOrders()
      ]).then(([applyRes, orderRes]) => {
        this.myMonthlyCar = (applyRes && applyRes.data) ? applyRes.data : []
        this.myActiveMonthlyOrders = (orderRes && orderRes.data) ? orderRes.data : []
      }).catch((err) => {
        console.error('Error loading monthly card stats:', err)
        this.myMonthlyCar = []
        this.myActiveMonthlyOrders = []
      })
    },
    toMonthCard(){
      this.$router.push({ name: 'MyMonthlyCard' });
    },
    goToVehicles() {
      this.$router.push({ name: 'VehicleList' });
    },
    goToOrders() {
      this.$router.push({ name: 'OrderList' });
    },
    goToParkingSpots() {
      this.$router.push({ name: 'ParkingSpotList' });
    },
    goToRsparkingMonthly() {
      this.$router.push({ name: 'MyRsparkingMonthly' });
    },
    goToInvoice() {
      this.$router.push({ name: 'InvoiceManagement' });
    },
    goToRefund() {
      this.$router.push('/user/postpaid/detail');
    },
    goToSettings() {
      this.$router.push({ name: 'UserSettings' });
    },
    goToBusiness() {
      this.$router.push({ name: 'BusinessCooperation' });
    },
    goToPrivacy() {
      this.$router.push({ name: 'PrivacyPolicy' });
    },
    goToLocation() {
      this.$router.push({ name: 'LocationSettings' });
    },
    goToFeedback() {
      this.$router.push({ name: 'UserFeedback' });
    },
    goToPostPaid() {
      this.$router.push('/user/postpaid/guidance');
    },
    goToParking() {
      this.$router.push('/parking');
    },
    goToCoupons() {
      this.$router.push('/user/coupons');
    }
  }
}
</script>

<style scoped>
.profile-page {
  min-height: calc(100vh - 55px);
  background-color: #f5f7fa;
  padding-bottom: 60px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: white;
}

.back-button, .more-button {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.website {
  text-align: center;
  padding: 8px 0;
  font-size: 12px;
  color: #999;
  background-color: white;
  border-bottom: 1px solid #eee;
}

/* User Info */
.user-profile-header {
  background-color: #e8f0ff;
  padding: 20px 15px;
  display: flex;
  align-items: center;
}

.avatar-container {
  margin-right: 15px;
  cursor: pointer;
}

.user-info {
  flex: 1;
}

.username {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.tagline {
  font-size: 12px;
  color: #666;
}

.service-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
  font-size: 12px;
}

.service-button .el-icon {
  font-size: 24px;
  margin-bottom: 2px;
}

/* User Stats */
.user-stats {
  display: flex;
  background-color: white;
  border-radius: 10px;
  padding: 15px 0;
}

.stat-item {
  flex: 1;
  text-align: center;
  position: relative;
  border-right: 1px solid #eee;
}

.stat-item:last-child {
  border-right: none;
}

.stat-value {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 12px;
  color: #666;
}

.stat-badge {
  position: absolute;
  top: -10px;
  right: 30px;
  background-color: #ff6034;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
}

/* Membership Banner */
.membership-banner {
  margin: 15px;
  background-color: #201606;
  border-radius: 10px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.membership-info {
  display: flex;
  align-items: center;
}

.membership-icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  background-color: #FECD57;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.membership-icon .el-icon {
  font-size: 24px;
  color: #201606;
}

.membership-title {
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.membership-savings {
  color: #FECD57;
  font-size: 12px;
}

.subscribe-button {
  background-color: #FECD57;
  color: #201606;
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
}

/* Services */
.section-title {
  font-size: 16px;
  font-weight: bold;
  padding: 15px;
  background-color: white;
  margin-top: 10px;
  border-bottom: 1px solid #f5f5f5;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  background-color: white;
  padding: 10px 0;
}

.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  position: relative;
}

.service-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  margin-bottom: 8px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;
}

.service-name {
  font-size: 12px;
  color: #333;
}

.badge {
  position: absolute;
  top: 5px;
  right: 10px;
  background-color: #ff6034;
  color: white;
  font-size: 8px;
  padding: 1px 4px;
  border-radius: 8px;
}

/* Service Icons */

.fuel-icon {
  background-color: #FF6B6B;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5z"/></svg>');
}


.fee-icon {
  background-color: #56CCF2;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8z"/></svg>');
}

.release-icon {
  background-color: #6FCF97;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 14H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"/></svg>');
}

.parking-icon {
  background-color: #4080FF;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>');
}

.payment-icon {
  background-color: #4080FF;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"/></svg>');
}

/* My Services Grid */
.my-services-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  background-color: white;
  padding: 10px 0;
}

.my-service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  position: relative;
}

.my-service-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.my-service-name {
  font-size: 12px;
  color: #333;
}

/* Icons for my services */
.car-icon, .order-icon, .invoice-icon, .refund-icon,
.privacy-icon, .location-icon, .settings-icon, .feedback-icon, .business-icon ,.spot-icon{
  background-size: 24px;
  background-position: center;
  background-repeat: no-repeat;
}

.car-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"/><circle cx="7.5" cy="14.5" r="1.5"/><circle cx="16.5" cy="14.5" r="1.5"/></svg>');
}

.order-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>');
}

.invoice-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/></svg>');
}

.refund-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>');
}

.privacy-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/></svg>');
}

.location-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/></svg>');
}

.settings-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>');
}

.feedback-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"/></svg>');
}

.business-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/></svg>');
}

.spot-icon {
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>');
}

.flag-icon {
  color: #333;
}
</style>
